module.exports = __webpack_public_path__ + "img/Natan 12 tripped out flower pattern.3f65d55b.jpg";